export default {"src":"/_next/static/media/inner-1.51b2d758.svg","height":74,"width":74,"blurWidth":0,"blurHeight":0};